import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import { ILeagueSchedule, ITeamSchedule } from "@src/types/api";

import Schedule from "@components/Schedule";

const LeagueSchedule = ({
    scheduleType,
}: {
    scheduleType: "league" | "team";
}): React.JSX.Element => {
    const { schedule } = useLoaderData() as {
        schedule: ILeagueSchedule | ITeamSchedule;
    };

    return (
        <div data-testid={`${scheduleType}ScheduleContent`}>
            <Container fluid="xs">
                <Row>
                    <Col>
                        {schedule?.games ? (
                            <Schedule
                                schedule={schedule.games.filter(g =>
                                    [
                                        "Scheduled",
                                        "Rescheduled",
                                        "Final",
                                    ].includes(g.status),
                                )}
                                scheduleType={scheduleType}
                            />
                        ) : (
                            <h2>No scheduled games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LeagueSchedule;
